import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppConfigService } from '@app/services/app-config.service';
import { PageData, PageDataService } from '@app/services/page-data.service';

@Component({
  selector: 'app-politica-privacidad',
  standalone: true,
  imports: [],
  templateUrl: './politica-privacidad.component.html',
  styleUrl: './politica-privacidad.component.scss',
})
export class PoliticaPrivacidadComponent implements OnInit {
  private appConfig = inject(AppConfigService);
  private route = inject(ActivatedRoute);
  private pageDataService = inject(PageDataService);

  pageData: PageData = this.route.snapshot.data['pageData'] ?? { sections: [] };

  owner: string = this.appConfig.business.fiscal_name;
  cif: string = this.appConfig.business.cif;
  address: string = `${this.appConfig.business.address}, ${this.appConfig.business.cp} ${this.appConfig.business.city}`;
  country: string = this.appConfig.business.country;
  domain: string = this.appConfig.domain;
  contact_email: string = this.appConfig.business.email;

  async ngOnInit(): Promise<void> {
    if (this.pageData.sections.length === 0) {
      this.pageData = await this.pageDataService.getPageData(3);
    }
  }
}
